// extracted by mini-css-extract-plugin
export default {"error-link":"utils-module__error-link__xtz4b"};